<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZIqDCQ/tc-custom/9781426878497.jpg?1740442438156" alt="This image is the cover for the book Duchess's Next Husband"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Duchess's Next Husband
      </h1>
      <p class="bookDescription body article font2">
        <b>From the <i>USA Today</i>–bestselling author: “Historical romance at its best, Brisbin’s Regency-era setting is aptly sketched with an economy of detail.” —<i>Booklist</i></b><br/><br/>All Miranda Warfield had ever wanted was to be a wife to a man, not a title, but her marriage to Adrian, Duke of Windmere, had been merely a polite ton alliance for years. Now, miraculously, the tender, loving Adrian of her youth had returned, making her feel like a bride again. But dare she trust their rekindled romance? For why was Adrian suddenly arranging clandestine meetings with his solicitor? And asking her opinions on several marriageable gentlemen of the ton? Did her husband’s eyes betray a secret his ardent lips denied. . . ?<br/><br/><b>Praise for Terri Brisbin</b><br/><br/>“A welcome new voice . . . you won’t want to miss.” —Susan Wiggs, #1 <i>New York Times</i>–bestselling author<br/><br/>“Lavish historical romance in the grand tradition from a wonderful talent.” —Bertrice Small, <i>New York Times</i>–bestselling author
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Terri Brisbin
      </h2>
      
      <p class="authorDescription body article">When <B><I>USA TODAY</I> bestselling author Terri Brisbin</B> is not being a glamorous romance author or in a deadline-writing-binge-o&#39;-mania, she&#39;s a wife, mom, GRANDMOM and dental hygienist in the southern New Jersey area. A three-time RWA RITA&reg; finalist,<B>&#160;Terri </B>has had more than 50 historical and paranormal romance novels, novellas and short stories published since 1998. You can visit her website:www.terribrisbin.com to learn more about her.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?aa0cbbda